export const TOS_STATUS = {
  DISK: 'tos-disk',
  INODES: 'tos-inodes',
  BACKUP: 'tos-backup',
  MYSQL: 'tos-mysql',
  CPU: 'tos-cpu',
  DMCA: 'tos-dmca',
  PISHING: 'tos-phishing',
};
